<template>
  <div class="flex flex-col gap-3">
    <div class="flex items-center gap-1">
      <LazyFrontendServiceFilterToggleableToggle v-if="toggleable" filter-id="service-provider:search" />
      <UInput
        v-if="toggleable || !disabledFilters.includes('service-provider:search')"
        v-model="filters.fuzzyServiceName"
        placeholder="Search provider e.g. Mind"
        size="lg"
        icon="i-heroicons-magnifying-glass"
        :ui="{ icon: { trailing: { pointer: '' } } }"
        trailing
        aria-label="Search for service provider by name"
      ></UInput>
    </div>
    <div v-for="filter in visibleProviders" :key="filter.key" class="flex items-center gap-1">
      <LazyFrontendServiceFilterToggleableToggle v-if="toggleable" :filter-id="filter.filterId" />
      <UCheckbox v-model="filter.selected" :label="filter.label" :ui="{ label: 'font-light' }">
        <template #label>
          <div class="flex items-center gap-x-2">
            {{ filter.label }}
            <HTooltip v-if="filter.toolTipContent" :text="filter.toolTipContent">
              <UIcon name="heroicons:information-circle" />
            </HTooltip>
          </div>
        </template>
      </UCheckbox>
    </div>
  </div>
</template>

<script setup lang="ts">
import { generateServiceFilterProviderTypesObjects } from '~/utils/serviceSearch/types/ServiceFilterServiceProviderTypes'

const props = defineProps({
  toggleable: Boolean
})

const serviceProviderTypes = reactive(generateServiceFilterProviderTypesObjects())

const { filters, disabledFilters } = storeToRefs(useServiceSearchStore())

// Filter out the providers that are disabled in Iframe settings
const visibleProviders = computed(() => {
  const providersArray = Object.values(serviceProviderTypes)
  if (props.toggleable) return providersArray
  const disabled = disabledFilters.value || []
  return providersArray.filter((x) => {
    // if it's hidden on the front end, filter it out
    if (x.frontEndHidden) return false
    // otherwise, filter it out if it's disabled
    return !disabled.includes(x.filterId)
  })
})

onMounted(() => {
  const storeServiceProviderTypes = filters.value.serviceProviderTypes
  for (const format of storeServiceProviderTypes) {
    if (serviceProviderTypes[format]) {
      serviceProviderTypes[format].selected = true
    }
  }
})

// watch the service provider types and update the store when they change
watch(
  serviceProviderTypes,
  (newServiceProviderTypes) => {
    const selectedServiceProviderTypes = Object.values(newServiceProviderTypes)
      .filter((format) => format.selected)
      .map((format) => format.key)
    filters.value.serviceProviderTypes = selectedServiceProviderTypes
  },
  { deep: true }
)

// watch the store and update the local when they change, if they differ
watch(
  () => filters.value.serviceProviderTypes,
  (newServiceProviderTypes) => {
    for (const format of Object.values(serviceProviderTypes)) {
      format.selected = newServiceProviderTypes.includes(format.key)
    }
  }
)
</script>
